import React from 'react';
import { useForm } from 'react-hook-form';
import { ActionButton } from 'components/ui/Button';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { discountCodeReferenceReg } from 'utils/validators';

import { StyledInput, MandatoryFieldLabel, ErrorField, Field, StyledSubmitField, StyledForm } from './ManageDiscountCode.styles';

const SearchDiscountCodeByCodeForm = ({ onSubmitSearch }) => {
  const { register, handleSubmit, formState } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const { errors } = formState;

  return (
    <StyledForm onSubmit={handleSubmit(onSubmitSearch)}>
      <Field>
        <MandatoryFieldLabel htmlFor="discountCode">
          <FormattedMessage id="payments.discountCodeReference" />
        </MandatoryFieldLabel>
        <StyledInput
          {...register('discountCode', {
            required: true,
            pattern: discountCodeReferenceReg
          })}
          type="text"
          id="discountCode"
          maxLength="30"
          validationState={errors.discountCode ? 'error' : ''}
        />
        {errors.discountCode && (
          <ErrorField id="error-discount-code">
            <FormattedMessage id="payments.discountCodeInvalid" />
          </ErrorField>
        )}
      </Field>
      <StyledSubmitField>
        <ActionButton data-cy="discount-code-search" type="submit" disabled={!formState.isValid}>
          <FormattedMessage id="vouchers.search" />
        </ActionButton>
      </StyledSubmitField>
    </StyledForm>
  );
};

SearchDiscountCodeByCodeForm.propTypes = {
  onSubmitSearch: PropTypes.func
};

export default SearchDiscountCodeByCodeForm;
